export default __webpack_public_path__ + "static/assets/f6a3d1f41d351e09fd7f1649b8320210.png";